// src/features/editor/components/studio/layout.ts
// Single source of truth for the editor studio panel widths.
//
// The block panel and AI sidebar are both PANEL_WIDTH (380px) wide. When the block
// panel floats over the canvas, the canvas reserves PANEL_WIDTH + 16px gutter (= 396px)
// of right padding so content isn't hidden behind the panel. Keep these in sync.

// В низком окне (`short`, см. tailwind.config) панель уже — 320, холст — 336.
export const PANEL_WIDTH = 380
export const PANEL_GUTTER = 16
export const CANVAS_PR = PANEL_WIDTH + PANEL_GUTTER // 396

/** Block panel width (floating card, md+). */
/** Ширина панели — только с `lg`: уже 1024 px панель выезжает справа поверх экрана
 *  по кнопке на холсте (`BlockPanelSheet`). На мониторах от 1800 px — шире:
 *  экраном `wide:`, не `min-[1800px]:` — произвольные варианты молча не попадают в
 *  сборку (экран `short` с `raw`-запросом, см. CLAUDE.md). */
export const PANEL_W_CLASS = 'lg:w-[380px] short:lg:w-[320px] wide:w-[480px]'
/**
 * Правая часть шапки редактора (сохранение · превью · публикация · настройки)
 * задаёт, где кончается левая группа — язык и кредиты: ровно над правым краем
 * панели инструментов холста (флаги · отмена · звук). Та стоит в `right-3`
 * (12) от холста, холст — в `CANVAS_PR_CLASS` (панель 380 + зазор 16 + отступ панели
 * от края 8), итого 416 от края; минус отступ шапки (16) и зазор группы (8) — 392.
 * Ширину панели менять ВМЕСТЕ с этим числом. Только с `lg`: на узком окне (~850)
 * эти 384px пустоты сжимали название курса до «Те…».
 */
export const HEADER_RIGHT_MIN_W_CLASS = 'lg:min-w-[392px] short:lg:min-w-[332px] wide:min-w-[492px]'
/** Canvas right padding when the block panel is open (PANEL_WIDTH + 16 gutter + 8 —
 *  панель отстоит от края окна на 8px, как сверху, а не прижата вплотную). */
export const CANVAS_PR_CLASS = 'lg:pr-[404px] short:lg:pr-[344px] wide:pr-[504px]'
/** AI sidebar fixed width. */
export const SIDEBAR_W_CLASS = 'w-[380px] min-w-[380px]'
/** AI-сайдбар: внешняя оболочка, анимирующая ширину 380 → 0. Внутренний слой держит SIDEBAR_W_CLASS. */
export const SIDEBAR_OPEN_W_CLASS = 'w-[380px]'
/**
 * Размер миниатюры экрана в ленте (и плитки «+», и скелета): пропорция экрана и
 * высота В ПИКСЕЛЯХ — высота ленты (`CourseTimeline`: 136 / short 118 / big 176)
 * минус отступы `BlockStrip` (pt-8 + pb-2 = 40). Не `h-full`: iOS Safari не считает
 * растянутую высоту flex-элемента определённой, процент от неё не срабатывал, и
 * ширина из `aspect-ratio` схлопывалась — миниатюра обрезалась в узкую полоску.
 * Высоту ленты менять ВМЕСТЕ с этими числами.
 */
export const THUMB_BOX_CLASS = 'aspect-[390/600] h-[96px] short:h-[78px] big:h-[136px]'
